export type RowScrollMetrics = {
  scrollLeft: number
  scrollWidth: number
  clientWidth: number
}

/**
 * Whether prev/next row controls should show for a horizontally scrollable row.
 * The ±1px tolerance avoids flicker from sub-pixel rounding (FP-3448).
 */
export const getRowScrollControlsVisibility = ({
  scrollLeft,
  scrollWidth,
  clientWidth,
}: RowScrollMetrics) => {
  const maxScrollLeft = scrollWidth - clientWidth

  return {
    isNextVisible: scrollLeft < maxScrollLeft - 1,
    isPrevVisible: scrollLeft > 1,
  }
}
